<template>
  <div class="pages agree_container">
    <hsjpro-priacy v-if="app === 'hsjpro'" />
    <hsj-priacy />
  </div>
</template>

<script>
import hsjPriacy from './hsj/Privacy.vue';
import hsjproPriacy from './hsjpro/Privacy.vue'
import { testApp } from '@/utils';
export default {
  name: "priacy",
  components: {hsjPriacy, hsjproPriacy},
  computed: {},
  data() {
    return {
      app: null
    }
  },
  created() {
    const app = this.$route.params?.app;
    const languages = this.$route.params?.app;
    this.app = app;
    // if (this.testApp('hsjpro')) {
    //   window.location.href = 'https://static.huashijie.art/hsjpro/agreement/#/privacy';
    // }
  },
  methods: {
    testApp,
    // isHsjPro() {
    //   return this.testApp('hsjpro');
    // }
  },
};
</script>
